import * as React from 'react'
import { Modal, Form } from 'antd'
import { FormattedMessage } from 'react-intl'
import BillForm from './BillForm'
import {
  useAddOrganizationInvoice,
  useAddSupplierInvoice,
  useModalVisible,
  useMode,
} from './queries'

const AddBillModal = () => {
  const [visible, setVisible] = useModalVisible()
  const addOrganizationInvoice = useAddOrganizationInvoice()
  const addSupplierInvoice = useAddSupplierInvoice()
  const mode = useMode()
  const [form] = Form.useForm()

  const isLoading =
    addOrganizationInvoice.isLoading || addSupplierInvoice.isLoading

  React.useEffect(() => {
    if (visible) {
      form.resetFields()
    }
  }, [visible])

  return (
    <Modal
      zIndex={1}
      visible={visible}
      cancelText={<FormattedMessage id="cancel" />}
      okText={<FormattedMessage id="confirm" />}
      onCancel={() => setVisible(false)}
      onOk={form.submit}
      okButtonProps={{ loading: isLoading }}
      cancelButtonProps={{ loading: isLoading }}
      destroyOnClose={true}
      width="100%"
      style={{ maxWidth: '800px' }}
    >
      <BillForm
        title={<FormattedMessage id="newInvoice" />}
        form={form}
        onChange={b => console.debug('updated bill', b)}
        onFinish={b => {
          console.debug('new bill', b)
          if (mode === 'organization') {
            if (!b.payer) {
              console.error('bill modal in organization mode has no payer', b)
              return
            }

            addOrganizationInvoice.mutate(
              {
                reference: b.reference,
                unitID: b.unitID,
                amount: b.amount,
                createdAt: b.createdAt.toDate(),
                dueAt: b.dueAt.toDate(),
                customer: b.payer,
                items: b.items,
                discount: b.discount,
                tax: b.tax,
                notifyPhonenumber: undefined,
                urlOk: undefined,
                urlFailed: undefined,
              },
              {
                onSuccess: () => setVisible(false),
              }
            )
          } else {
            if (!b.companyInfo) {
              console.error('bill modal in supplier mode has no payer', b)
              return
            }

            addSupplierInvoice.mutate(
              {
                reference: b.reference,
                unitID: b.unitID,
                amount: b.amount,
                createdAt: b.createdAt.toDate(),
                dueAt: b.dueAt.toDate(),
                items: b.items,
                organization: b.companyInfo.name,
                email: b.companyInfo.email,
                discount: b.discount,
                tax: b.tax,
                notifyPhonenumber: undefined,
                urlOk: undefined,
                urlFailed: undefined,
              },
              { onSuccess: () => setVisible(false) }
            )
          }
        }}
      />
    </Modal>
  )
}

export default AddBillModal
